<template>
<div class="page home-page home-mines">
	<navbar />
	<mines-sidebar />
	<statistic-bar />
</div>
</template>

<script>
import Navbar from '@/components/main/Navbar'
import MinesSidebar from './components/MinesSidebar'
import StatisticBar from '@/components/main/StatisticBar'
import { runStatisticAnimation } from '@/utils/helpers'

export default {
	components: {
		Navbar,
		MinesSidebar,
		StatisticBar
	},
	mounted() {
		runStatisticAnimation()
	}
}
</script>

<style lang="scss">
.home-mines {
	background-image: url('../../assets/images/back_2.jpg');
	position: absolute;
	z-index: 1;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	background-size: cover;

	.navbar {
		animation: fadeIn 2s linear 1s forwards;
	}
}
</style>
